import React from "react";
import {
  Card,
} from "antd";

import Map from "./map";

const DivisionMap = ({ regions }) => {


  // This effect sets loading to true every time coordinates change
  if (!regions) return null;
  return (
    <>
      <Card
        style={{ minWidth: 300, width: "100%", height: "100%", padding: 0, overflow: "hidden" }}
        bodyStyle={{ height: "100%", width: "100%", padding: 0 }}
        bordered

      >
        <Map regions={regions} />
      </Card>
    </>
  );
};

export default DivisionMap;
